/***********************************************************************
 *                           二维码工具类                               *
 * ********************************************************************/
import QRCode from 'qrcodejs2'

/* 生成二维码 */
var qrcode
//初始化
export function createdQRcode(param, id) {
  let divId
  if (id) {
    divId = id
  } else {
    divId = 'qrcode'
  }
  qrcode = new QRCode(divId, {
    width: 200,
    height: 200, // 高度

    // text: param ,// 二维码内容

    render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    // colorDark: "#000000",
    // colorLight: "#ffffff",
    colorDark: '#000000',
    colorLight: '#ffffff',
    correctLevel: QRCode.CorrectLevel.H
  })
}
//生成二维码
export function makeCode(param, callback) {
  qrcode.clear() //清除代码
  qrcode.makeCode(param) //生成二维码
  getQRCodeFile(callback)
}
//获取base64文件
function getQRCodeFile(callback) {
  let file = document
    .getElementById('qrcode')
    .getElementsByTagName('img')[0]
    .getAttribute('src')
  if (file) {
    callback(file)
  } else {
    setTimeout(function() {
      getQRCodeFile(callback)
    }, 500)
    return
  }
}



// WEBPACK FOOTER //
// ./src/utils/QRCode.js